/**
 * RESPONSIBILITY: the stack of blocks down the /adc page.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { AdcBlockRow } from './block';

@Section({ name: SectionName.AdcBlocks, label: 'Austin Desi Christmas - Blocks' })
export class AdcBlocksSection {
  @List({
    label: 'Blocks', of: () => AdcBlockRow, maxItems: 40,
    description: 'Add, remove and reorder. Each block is drawn in this order.',
  })
  blocks!: AdcBlockRow[];
}
